import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Menu, MenuItem, ListItemText, IconButton } from '@mui/material'
import { get, noop } from 'lodash'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { useSelector } from 'react-redux'
import { useUnlinkLateFeesToAccountMutation } from 'api/pricing/lateFeesCrud'
import { handleError } from 'utils/error'

const LateFeesCustomerActionMenu = ({ lateFee, onClick = noop, onClose = noop }) => {
  const { id } = lateFee
  const customerDetails = useSelector(state => get(state, 'CustomersReducer.customerDetails', null))
  const accountId = useMemo(() => get(customerDetails, 'id'), [])
  const [unlinkLateFeesToAccount] = useUnlinkLateFeesToAccountMutation()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const handleClick = event => {
    onClick(lateFee)
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
    onClose()
  }

  const handleRemoveLateFee = () => {
    unlinkLateFeesToAccount({
      accountId,
      lateFees: [id],
    })
      .unwrap()
      .then(() => {})
      .catch(handleError)
      .finally(handleClose)
  }

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="late-fees-action-menu"
        slotProps={{
          paper: {
            sx: {
              border: '1px solid',
              borderColor: 'divider',
            },
          },
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleRemoveLateFee}>
          <ListItemText>Remove late fee from account</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}

LateFeesCustomerActionMenu.propTypes = {
  onClose: PropTypes.func,
  lateFee: PropTypes.object,
  onClick: PropTypes.func,
}

export default LateFeesCustomerActionMenu
